import { MeetingContainerAPI, MeetingSessionOvenMediaReceiver } from "@kalyzee/kast-web-sdk";
import SurveyExpertContainer from "../../survey/SurveyExpertContainer";
import { PedagogyContextState } from "../../../pages/master/pedagogy/context";
import { useRefAutoUpdate } from "@kalyzee/kast-web-sdk/web-components";
import { useEffect } from "react";

export interface PedagogySurveyContainerProps {
  meetingContainerAPI?: MeetingContainerAPI;
  context: PedagogyContextState | undefined;
  audioValidator?: (session: MeetingSessionOvenMediaReceiver) => boolean;
  style?: React.CSSProperties;
}

export const PedagogySurveyContainer = ({
  meetingContainerAPI,
  context,
  style = {},
  audioValidator,
}: PedagogySurveyContainerProps) => {
  const contextRef = useRefAutoUpdate(context);

    // ---------------------------------------------------------------------- //
  // ---------------------------   EFFECT ----------------------------- //
  // ---------------------------------------------------------------------- //

  useEffect(() => {
    if (!audioValidator) return;
    const validator = contextRef.current?.addAudioValidator((session) => {
      return audioValidator(session);
    });
    return () => {
      validator?.flush();
    };
  }, [audioValidator]);


  // ---------------------------------------------------------------------- //
  // ---------------------------   RENDER ----------------------------- //
  // ---------------------------------------------------------------------- //

  return (
    <div style={{ 
      width: "100%", 
      height: "100%",
      padding: 10, 
      backgroundColor: "transparent",
      ...style,
    }}>
      <SurveyExpertContainer 
        meetingContainerAPI={meetingContainerAPI}
      />
    </div>
  );
};